import { Suspense } from 'react';

// Loadable wrapper for lazy-loaded components
// The global slim loader at the top will show loading state
// No need for individual component spinners

const Loadable =
  (Component: any, Skeleton = null) =>
  (props: any) =>
    (
      <Suspense fallback={Skeleton}>
        <Component {...props} />
      </Suspense>
    );

export default Loadable;
